// FETCH ALL CHECKING DC
export const FETCH_CHECKING_DC_MASTER_REQUEST = 'FETCH_CHECKING_DC_MASTER_REQUEST';
export const FETCH_CHECKING_DC_MASTER_SUCCESS = 'FETCH_CHECKING_DC_MASTER_SUCCESS';
export const FETCH_CHECKING_DC_MASTER_FAILURE = 'FETCH_CHECKING_DC_MASTER_FAILURE';

// CREATE CHECKING DC
export const CREATE_CHECKING_DC_MASTER_REQUEST = 'CREATE_CHECKING_DC_MASTER_REQUEST';
export const CREATE_CHECKING_DC_MASTER_SUCCESS = 'CREATE_CHECKING_DC_MASTER_SUCCESS';
export const CREATE_CHECKING_DC_MASTER_FAILURE = 'CREATE_CHECKING_DC_MASTER_FAILURE';

// UPDATE CHECKING DC
export const UPDATE_CHECKING_DC_MASTER_REQUEST = 'UPDATE_CHECKING_DC_MASTER_REQUEST';
export const UPDATE_CHECKING_DC_MASTER_SUCCESS = 'UPDATE_CHECKING_DC_MASTER_SUCCESS';
export const UPDATE_CHECKING_DC_MASTER_FAILURE = 'UPDATE_CHECKING_DC_MASTER_FAILURE';

// FETCH SINGLE STATE OF CHECKING DC
export const FETCH_SINGLE_CHECKING_DC_MASTER_REQUEST = 'FETCH_SINGLE_CHECKING_DC_MASTER_REQUEST';
export const FETCH_SINGLE_CHECKING_DC_MASTER_SUCCESS = 'FETCH_SINGLE_CHECKING_DC_MASTER_SUCCESS';
export const FETCH_SINGLE_CHECKING_DC_MASTER_FAILURE = 'FETCH_SINGLE_CHECKING_DC_MASTER_FAILURE';

// DELETE CHECKING DC
export const DELETE_CHECKING_DC_MASTER_REQUEST = 'DELETE_CHECKING_DC_MASTER_REQUEST';
export const DELETE_CHECKING_DC_MASTER_SUCCESS = 'DELETE_CHECKING_DC_MASTER_SUCCESS';
export const DELETE_CHECKING_DC_MASTER_FAILURE = 'DELETE_CHECKING_DC_MASTER_FAILURE';

export const RESET_CHECKING_DC_MASTER_INFO = 'RESET_CHECKING_DC_MASTER_INFO';

export const CREATE_CHECKING_DC_MASTER_FORM = 'CREATE_CHECKING_DC_MASTER_FORM';

export const UPDATE_CHECKING_DC_MASTER_FORM = 'UPDATE_CHECKING_DC_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_CHECKING_DC_DETAILS = 'NAVIGATE_CHECKING_DC_DETAILS';

// NAVIGATE TO CHECKING DC COMPONENT
export const NAVIGATE_CHECKING_DC_MASTER = 'NAVIGATE_CHECKING_DC_MASTER';
